import { faChevronRight, faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card } from 'reactstrap'
import {
  resetSetupSystemData,
  setSystemSidebarRoute,
} from 'store/Recruitment/actions'
import {
  SYSTEM_SETUP_CANDIDATE_CATEGORY,
  SYSTEM_SETUP_JOB_CATEGORY,
  SYSTEM_SETUP_JOB_STAGE,
  SYSTEM_SETUP_OFFER_LETTER_SETTINGS,
  SYSTEM_SETUP_SALARY_TYPE,
  SYSTEM_SETUP_SCREEN_INDICATOR,
  SYSTEM_SETUP_SCREENING_TYPE,
} from 'store/Recruitment/reducer'
import CommonRowTable from './CommonRowTable'
import CreateModal from './CreateModal'
import OfferLetterSettings from './OfferLetterSettings'
import './styles.css'

function SystemSetup() {
  const dispatch = useDispatch()
  const { systemSetupSidebarRoutes, activeSystemSetupSidebarRoute } =
    useSelector((store) => store.recruitment)

  const [showModal, setShowModal] = useState()

  useEffect(() => {
    if (!showModal) {
      dispatch(resetSetupSystemData())
    }
  }, [showModal, dispatch])

  return (
    <>
      <Card
        onClick={() => setShowModal(true)}
        className={`bg-info text-white plus-button ${
          activeSystemSetupSidebarRoute === SYSTEM_SETUP_OFFER_LETTER_SETTINGS
            ? 'invisible'
            : ''
        }`}
      >
        <FontAwesomeIcon icon={faPlus} className='' />
      </Card>

      <div className='system-setup-container' style={{ display: "grid", gap: '2rem' }}>
        <Card style={{ height: 'fit-content' }}>
          {systemSetupSidebarRoutes.map((route) => (
            <div
              onClick={() => dispatch(setSystemSidebarRoute(route))}
              className={`sidebar-route d-flex justify-content-between align-items-center ${
                route === activeSystemSetupSidebarRoute
                  ? 'bg-info text-white'
                  : ''
              }`}
              key={route}
            >
              <span>{route}</span> <FontAwesomeIcon icon={faChevronRight} />
            </div>
          ))}
        </Card>
        <Card className='p-4'>
          {activeSystemSetupSidebarRoute === SYSTEM_SETUP_JOB_CATEGORY && (
            <CommonRowTable
              setShowModal={setShowModal}
              columns={[
                {
                  headerName: 'Category',
                  field: 'category',
                  flex: 1,
                },
              ]}
            />
          )}
          {activeSystemSetupSidebarRoute === SYSTEM_SETUP_JOB_STAGE && (
            <CommonRowTable
              setShowModal={setShowModal}
              columns={[
                {
                  headerName: 'Name',
                  field: 'name',
                  flex: 1,
                },
              ]}
              reordable={true}
            />
          )}
          {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SALARY_TYPE && (
            <CommonRowTable
              setShowModal={setShowModal}
              columns={[
                {
                  headerName: 'Salary Type',
                  field: 'name',
                  flex: 1,
                },
              ]}
            />
          )}
          {activeSystemSetupSidebarRoute ===
            SYSTEM_SETUP_CANDIDATE_CATEGORY && (
            <CommonRowTable
              setShowModal={setShowModal}
              columns={[
                {
                  headerName: 'Name',
                  field: 'name',
                  flex: 1,
                },
              ]}
            />
          )}
          {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SCREENING_TYPE && (
            <CommonRowTable
              setShowModal={setShowModal}
              columns={[
                {
                  headerName: 'Name',
                  field: 'name',
                  flex: 1,
                },
              ]}
            />
          )}
          {activeSystemSetupSidebarRoute === SYSTEM_SETUP_SCREEN_INDICATOR && (
            <CommonRowTable
              setShowModal={setShowModal}
              columns={[
                {
                  headerName: 'Name',
                  field: 'name',
                  flex: 1,
                },
                {
                  headerName: 'Screening Type',
                  field: 'screeningType',
                  flex: 1,
                },
              ]}
            />
          )}
          {activeSystemSetupSidebarRoute ===
            SYSTEM_SETUP_OFFER_LETTER_SETTINGS && <OfferLetterSettings />}
        </Card>
      </div>
      {showModal && (
        <CreateModal showModal={showModal} setShowModal={setShowModal} />
      )}
    </>
  )
}

export default SystemSetup
